import * as angular from "angular";
import * as _ from "lodash";
import { Appointment } from "../../models/appointment.model";
import { PermissionCheck } from "../../shared/permission";
import { AppointmentDataProvider } from "../../data-provider/appointment.dp";
import { Utils } from "../../helper/utils.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { DialogUtils } from "../../helper/dialog.helper";
import { AppointmentFilter } from "../../models/appointment-filter.model";
import { CheckManager } from "../../shared/check-manager";
import { User } from "../../models/user.model";
import { UserDataProvider } from "../../data-provider/user.dp";

let AppointmentsComponent = {
    selector: "vcAppointments",
    templateUrl: "/angular/components/planner/appointments.component.html",
    bindings: {},
    controller: class AppointmentsController {
        public upcomingLoading: boolean = false;
        public overdueLoading: boolean = false;
        public completedLoading: boolean = false;
        public activeTab: string = "upcoming";
        public checkManager: CheckManager;
        private dataProvider: AppointmentDataProvider;
        public permissionProvider: PermissionCheck;
        public activeUser: User;
        private $scope: any;
        private modelsUtils: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;
        public filters: AppointmentFilter;
        public count: any = {
            upcoming: 0,
            overdue: 0,
            completed: 0,
        };

        public appointments: any = {
            upcoming: [],
            overdue: [],
            completed: [],
        };
        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            ModelsUtils: any,
            __app_type: string,
            AppointmentDataProvider: AppointmentDataProvider,
            ToastUtils: ToastUtils,
            Utils: Utils,
            PermissionCheck: PermissionCheck,
            UserDataProvider: UserDataProvider
        ) {
            Utils.runWootric();

            this.dataProvider = AppointmentDataProvider;
            this.permissionProvider = PermissionCheck;
            this.$scope = $scope;
            this.toast = ToastUtils;
            this.modelsUtils = ModelsUtils;
            this.dialog = DialogUtils;
            this.activeUser = UserDataProvider.getActiveUser();
            this.getAll();
            this.filters.tab = "upcoming";
        }

        getAll(): void {
            this.clearTab("upcoming");
            this.clearTab("overdue");
            this.clearTab("completed");
            this.getTabAppointments("upcoming");
            this.getTabAppointments("overdue");
            this.getTabAppointments("completed");
        }

        getTabAppointments(tab: string = "today", offset: number = null): void {
            if (
                (tab == "upcoming" && this.upcomingLoading) ||
                (tab == "overdue" && this.overdueLoading) ||
                (tab == "completed" && this.completedLoading)
            ) {
                return;
            }
            if (!offset) {
                this.clearTab(tab);
            }
            var filters: AppointmentFilter;
            if (!this.filters) {
                this.filters = this.getFilters();
            }
            filters = angular.copy(this.filters);
            filters.tab = tab;
            this.setLoading(tab, true);
            this.dataProvider.all(filters, offset).then(
                (data: any) => {
                    angular.forEach(data.data, (appointment: object) => {
                        this.appointments[tab].push(
                            this.modelsUtils.appointment(appointment)
                        );
                    });

                    if (data.meta) {
                        this.count[tab] = data.meta.count ?? 0;
                    }
                    this.checkManager = new CheckManager(
                        this.appointments[this.activeTab]
                    );
                    this.checkManager.checkAll(false);

                    this.checkManager.setTotalCount(
                        this.getCount(this.activeTab)
                    );
                    this.setLoading(tab, false);
                },
                (error: object) => {
                    this.setLoading(tab, false);

                    this.toast.error(error);
                }
            );
        }

        setLoading(tab: string, loading: boolean): void {
            if (tab == "upcoming") {
                this.upcomingLoading = loading;
            }
            if (tab == "overdue") {
                this.overdueLoading = loading;
            }
            if (tab == "completed") {
                this.completedLoading = loading;
            }
        }
        setActiveTab(tab: string): void {
            this.getTabAppointments(tab);
            this.activeTab = tab;
            this.filters.tab = tab;
        }

        getFilters(): AppointmentFilter {
            let filters = this.modelsUtils.appointmentFilter({});
            let localData = filters.getLocalStorage();
            if (localData) {
                filters.setData(localData);
            } else {
                filters.setData();
            }
            return filters;
        }

        openFiltersDialog(ev: any): void {
            const activeTab: string = this.activeTab;
            let filters: AppointmentFilter = this.filters;
            this.dialog
                .show({
                    component: "vc-appointment-filters-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    ariaLabel: "Appointment Filters",
                    locals: {
                        filters: angular.copy(filters),
                        appointmentTab: activeTab,
                    },
                })
                .then((filters: AppointmentFilter) => {
                    this.filters.setData(filters);
                    this.filters.setNumAppliedFilters();

                    this.getTabAppointments("upcoming");
                    this.getTabAppointments("overdue");
                    this.getTabAppointments("completed");
                });
        }

        scrollLoad(): void {
            const activeTab = this.activeTab;
            let offset = this.appointments[activeTab].length;
            this.getTabAppointments(activeTab, offset);
        }

        saveAppointment(appointment: Appointment): void {
            this.dataProvider.update(appointment).then(
                (newData: any) => {
                    appointment.setData(newData);
                    this.getTabAppointments(this.activeTab);
                    this.toast.success("Appointment Updated");
                },
                (error: object) => {
                    this.toast.error(error);
                }
            );
        }

        openBulkAssignDialog(appointment: Appointment, ev: any): void {
            let assignee = appointment.assignee;
            this.dialog
                .show({
                    component: "vc-appointment-assignee",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        assignee: null,
                    },
                    size: "med",
                    ariaLabel: "Bulk assignee appointments",
                })
                .then((assignee: User) => {
                    this.bulkAction({ uid: assignee.uid ?? null });
                });
        }

        openBulkStatusDialog(ev: object): void {
            this.dialog
                .show({
                    component: "vc-appointment-status",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    ariaLabel: "Bulk edit appointments status",
                    scope: this.$scope,
                    locals: {
                        status: "",
                        permission:
                            this.permissionProvider.hasPermission(
                                "EDIT_APPOINTMENTS"
                            ) ||
                            this.permissionProvider.hasPermission("CANVASSER"),
                        bulk: true,
                    },
                })
                .then((status: string) => {
                    this.bulkAction({ status });
                });
        }

        openSettingsDialog(ev: object): void {
            this.dialog.show({
                component: "vc-appointment-settings",
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: true,
                ariaLabel: "Appointments settings",
                scope: this.$scope,
                locals: {},
            });
        }

        openBulkDeleteDialog(ev: any): void {
            this.dialog
                .show({
                    component: "vc-appointment-delete",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    ariaLabel: "Bulk delete appointments status",
                    scope: this.$scope,
                    locals: {
                        permission:
                            this.permissionProvider.hasPermission(
                                "DELETE_APPOINTMENTS"
                            ) ||
                            this.permissionProvider.hasPermission("CANVASSER"),
                    },
                })
                .then(() => {
                    const tab = this.activeTab;
                    this.dataProvider
                        .bulkDelete(this.filters, this.checkManager)
                        .then(
                            () => {
                                this.clearTab(tab);
                                this.getTabAppointments(tab);
                                this.toast.success("Appointments Deleted");
                            },
                            (error: object) => {
                                this.toast.error(error);
                            }
                        );
                });
        }

        bulkAction(data: object): void {
            const tab = this.activeTab;
            this.dataProvider
                .bulkEdit(data, this.filters, this.checkManager)
                .then(
                    () => {
                        this.clearTab(tab);
                        this.getTabAppointments(tab);
                        this.toast.success("Appointments Updated");
                    },
                    (error: object) => {
                        this.toast.error(error);
                    }
                );
        }

        getCount(tab: string): number {
            return this.count[tab];
        }

        clearAll(): void {
            this.count = {
                upcoming: 0,
                overdue: 0,
                completed: 0,
            };
            this.appointments = {
                upcoming: [],
                overdue: [],
                completed: [],
            };
        }

        clearTab(tab: string): void {
            this.appointments[tab] = [];
        }
    },
};

angular
    .module("planner")
    .component(AppointmentsComponent.selector, AppointmentsComponent);
